import React from 'react';
import { useTranslation } from "react-i18next";
import styled from 'styled-components';
import '../../App.css';
import Footer from '../Footer';
import SectionTitle from '../SectionTitle';
import useReveal from '../hooks/useReveal';
import useDocumentMeta from '../hooks/useDocumentMeta';

const ProjectStyle = styled.div`
  padding: 10rem 0;
  z-index: 1;
  position: relative;
  transition: 0.4s ease-in-out;

  .projects__allItems {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 5rem;
    margin-top: 5rem;
  }
  
`;


export default function Stream() {
  const {t} = useTranslation(['stream']);
  useDocumentMeta('Stream', "Watch Afonso Pereira (Osnofaz) stream live on Twitch — competitive gaming and dev streams.");
  const [streamRef, streamVisible] = useReveal();

    return (
        <>
          <ProjectStyle>
          <div className="container" style={{ marginBottom: "55px" }}>
            <SectionTitle
              heading="STREAM"
              subheading={t("streamdesc")}
            />
            <div className={`streamcontainer reveal ${streamVisible ? 'reveal--visible' : ''}`} ref={streamRef}>
              <div className='streamvideo'>
                <iframe className="streammobile" 
                  title="streamplayer" 
                  src="https://player.twitch.tv/?channel=osnofaz&parent=afonsopereira.com&parent=www.afonsopereira.com&parent=localhost"
                  frameBorder="0" 
                  allowFullScreen
                  scrolling="yes" 
                  height="500" 
                  width="900">
                </iframe>
              </div>
            <div className='streamchat'>
              <iframe
              className="streammobile"
              title="streamchatwindow"
              id="chat_embed"
              src="https://www.twitch.tv/embed/osnofaz/chat?parent=afonsopereira.com&parent=www.afonsopereira.com&parent=localhost"
              height="500"
              width="350">
              </iframe>
            </div>
            </div>
          </div>
          </ProjectStyle>
          <Footer />
        </>
      );
    }
